import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReportPage from '../ReportPage';
import CartoonLoader from '../CartoonLoader';
import { useData } from '../DataContext';

export default function LiveClassReportPage() {
  const navigate = useNavigate();
  const { liveClassData, liveClassLoading, refetchLiveClass } = useData();
  const [scheduleData, setScheduleData] = useState([]);

  useEffect(() => {
    setScheduleData(liveClassData);
  }, [liveClassData]);

  if (liveClassLoading) {
    return <CartoonLoader message="Please wait until the classes are caught..." />;
  }

  return (
    <ReportPage
      scheduleData={scheduleData}
      onBack={() => navigate('/live-class')}
      onRefetch={refetchLiveClass}
    />
  );
}